import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { useEffect, useState } from 'react';
import React from "react";

export default function EditorField({ onEditorChange, value = "" , label = ""}) {

    const [data, setData] = useState(``)

    useEffect(() => {
        if (value != undefined) {
            onEditorChange(value)
            setData(value)
        }
    }, [value])


    return <div>
        <label className="text-gray-500 block pb-2">{label}</label>
        <CKEditor
            editor={ClassicEditor}
            config={{
                language: 'fa'
            }}
            onChange={(event, editor) => {
                const data = editor.getData();
                onEditorChange(data)
                setData(data)
            }}
            data={data} />
    </div>
}